import http from './http'

export default {
  getList: params => http.get('/v2/secretaries', { params }),
  setSuperSecretary: (memberId, isSuperSecretary) => http.patch(`/v2/members/${memberId}/super-secretary`, { is_super_secretary: isSuperSecretary }, { silent: true, localSuccess: true })
}



// WEBPACK FOOTER //
// ./src/services/api/secretaries.js